<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Dn Charge Detail Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Day</u></label>
        <input type="date" [(ngModel)]="filterable.day" class="form-control" placeholder="From">
      </div>
      <div class="col-10 text-right align-self-end">
        <!-- <button class="btn btn-primary btn-sm mr-2" (click)="back()">Back</button> -->
        <button class="btn btn-danger btn-sm mr-2" (click)="close()">Close</button>
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
        <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
        <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="emptyResult">
  <div class="loader" *ngIf="loading">Loading...</div>
  <div class="alert alert-warning mt-3 w-100" *ngIf="!loading">Empty Result...</div>
</div>

<div *ngIf="!emptyResult">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs mt-4">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <h5><span *ngIf="resultName != ''" class="font-weight-bold font-italic text-danger">{{resultName}}: &nbsp;</span>By ShortCode({{reportsWrappr.reports.length}})</h5>
      </a>
      <ng-template ngbNavContent>
        <div class="mt-3 mb-2 row">
          <div class="col-12 text-left align-middle">
            <div class="form-check form-check-inline align-middle">
              <input class="form-check-input text-danger" type="checkbox" id="checkbox_1" [(ngModel)]="redRowCheckbox">
              <label class="form-check-label text-danger font-weight-bold" for="checkbox_1">RED(&gt;=5%)</label>
            </div>
            <div class="form-check form-check-inline align-middle">
              <input class="form-check-input text-success" type="checkbox" id="checkbox_2" [(ngModel)]="greenRowCheckbox">
              <label class="form-check-label text-success font-weight-bold" for="checkbox_2">GREEN(&gt;=1%)</label>
            </div>
            <div class="form-check form-check-inline align-middle">
              <input class="form-check-input text-dark" type="checkbox" id="checkbox_3" [(ngModel)]="otherRowCheckbox">
              <label class="form-check-label text-dark font-weight-bold" for="checkbox_3">Other</label>
            </div>
          </div>
        </div>
        <table id="dnChargeList" class="table table-striped table-bordered mt-3" style="width:100%">
          <thead class="text-center">
            <tr>
              <th>ShortCode</th>
              <th>Operator</th>
              <th>keyword</th>
              <th>Affiliate</th>
              <th>Client</th>
              <th>Share</th>
              <th>spiderAccount</th>
              <th>Sub Before Day</th>
              <th>UnSub Before Day</th>
              <th>Retention</th>
              <th>DN</th>
              <th>Expected DN</th>
              <th>Expected DN Difference</th>
              <th>Success DN</th>
              <th>Amount</th>
              <th>Success DN Rate</th>
              <th>Success Expected DN Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dnCharge of reportsWrappr.reports">
              <ng-container *ngIf="isDisplay(dnCharge.dnDiffRateVal)">
                <td class="text-center bg-danger text-white font-weight-bold" *ngIf="dnCharge.dnDiffRateVal > 5 || dnCharge.dnDiffRateVal == 5">
                  {{dnCharge.shortCode}}
                </td>
                <td class="text-center bg-success text-white font-weight-bold" *ngIf="dnCharge.dnDiffRateVal < 5 && (dnCharge.dnDiffRateVal > 1 || dnCharge.dnDiffRateVal == 1) ">
                  {{dnCharge.shortCode}}
                </td>
                <td class="text-center text-dark font-weight-bold" *ngIf="dnCharge.dnDiffRateVal < 1 ">
                  {{dnCharge.shortCode}}
                </td>
                <td class="text-center">{{dnCharge.operator}}</td>
                <td class="text-center">{{dnCharge.keyword}}</td>
                <td class="text-center">{{dnCharge.affiliate}}</td>
                <td class="text-center">{{dnCharge.client}}</td>
                <td class="text-center">{{dnCharge.share}}</td>
                <td class="text-center">{{dnCharge.spiderAccount}}</td>
                <td class="text-right">{{dnCharge.sub}}</td>
                <td class="text-right">{{dnCharge.unsub}}</td>
                <td class="text-right">{{dnCharge.retention}}</td>
                <td class="text-right">{{dnCharge.dn}}</td>
                <td class="text-right">{{dnCharge.expectedDn}}</td>
                <td class="text-right">{{dnCharge.dnDiff}}</td>
                <td class="text-right">{{dnCharge.dnSuccess}}</td>
                <td class="text-right">{{dnCharge.amount}}</td>
                <td class="text-right">{{dnCharge.successDnRate}}</td>
                <td class="text-right">{{dnCharge.successExpectedDnRate}}</td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <h5>By Account({{reportsWrappr.accounts.length}})</h5>
      </a>
      <ng-template ngbNavContent>
        <table id="dnChargeAccountList" class="table table-striped table-bordered mt-3" style="width:100%">
          <thead class="text-center">
            <tr>
              <th>Account</th>
              <th>Sub Before Day</th>
              <th>UnSub Before Day</th>
              <th>Retention</th>
              <th>DN</th>
              <th>Expected DN</th>
              <th>Expected DN Difference</th>
              <th>Success DN</th>
              <th>Amount</th>
              <th>Success DN Rate</th>
              <th>Success Expected DN Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dnCharge of reportsWrappr.accounts">
              <td class="text-center">
                  {{dnCharge.spiderAccount}}
              </td>
              <td class="text-right">{{dnCharge.sub}}</td>
              <td class="text-right">{{dnCharge.unsub}}</td>
              <td class="text-right">{{dnCharge.retention}}</td>
              <td class="text-right">{{dnCharge.dn}}</td>
              <td class="text-right">{{dnCharge.expectedDn}}</td>
              <td class="text-right">{{dnCharge.dnDiff}}</td>
              <td class="text-right">{{dnCharge.dnSuccess}}</td>
              <td class="text-right">{{dnCharge.amount}}</td>
              <td class="text-right">{{dnCharge.successDnRate}}</td>
              <td class="text-right">{{dnCharge.successExpectedDnRate}}</td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2 mb-4"></div>
</div>
<!-- <div class="table-responsive"> -->

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
